import { render, staticRenderFns } from "./selectedEmployeeCard.vue?vue&type=template&id=6858993b&scoped=true"
import script from "./selectedEmployeeCard.vue?vue&type=script&lang=js"
export * from "./selectedEmployeeCard.vue?vue&type=script&lang=js"
import style0 from "./selectedEmployeeCard.vue?vue&type=style&index=0&id=6858993b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6858993b",
  null
  
)

export default component.exports